export enum Gender {
  MALE = "M",
  FEMALE = "F",
  NOT_RELEVANT = "X",
}

export enum FormStatus {
  VALID = "VALID",
  INVALID = "INVALID",
  PENDING = "PENDING",
  DISABLED = "DISABLED",
}

export enum MessageType {
  INFO = 0,
  ERROR = 1,
  DEBUG = 2,
}

export enum Route {
  COMPOSE = 0,
  USER_DATA = 1,
  COMPANY_DATA = 2,
  VERIFY = 3,
  AGREEMENT = 4,
  CONFIRMATION = 5,
  ISSUER = 50,
  PAYMENT = 100,
}

export enum ScrollPositionId {
  TOP = "ns-app",
  PRODUCT_EXTRAS = "bca-choose-extras",
  INPUT_INVALID = "nes-error-message",
  CONTACT_PERSON = "bca-user-form",
  IMAGE = "bca-choose-image",
}

export enum AddonIdentifier {
  Deelauto = "DLA",
  Taxi = "TAX",
  WorldWide = "INT",
  Bike = "OVF",
  QPark = "QPK",
  Meeting = "BTM",
  DeelScooter = "DLS",
  Dott = "DEF",
  MyWheels = "DLA",
  Deelfiets = "DLF",
}

export enum ProductIdentifier {
  GeenAbonnement = "BCB",
  Dal = "BCD",
  Traject = "BCT",
  TreinVrij = "BCS",
  OVVrij = "VRIJ",
}

export enum TravelerClass {
  FIRST = "1",
  SECOND = "2",
}

export enum DialogIdentifier {
  ChooseRoute = "chooseRoute",
  Receipt = "receipt",
  Confirm = "confirm",
  Image = "image",
}
